import React from 'react';

/**
 * AuthWrapper - Simple wrapper component
 * Place this at the root level of your app (in App.js)
 */
const AuthWrapper = ({ children }) => {
  return <>{children}</>;
};

export default AuthWrapper;
